"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M13.4135 17H6.58719C6.15228 17 5.79097 16.6683 5.75501 16.2367L5.00061 7.22583C4.99141 7.10417 5.08676 7 5.20887 7H14.791C14.914 7 15.0093 7.10417 14.9993 7.22583L14.2457 16.2367C14.2098 16.6683 13.8484 17 13.4135 17ZM8 9V15H9V9H8ZM11 9V15H12V9H11ZM14.1667 4C14.6275 4 15 4.448 15 5V5.75C15 5.888 14.9067 6 14.7917 6H5.20833C5.09333 6 5 5.888 5 5.75V5C5 4.448 5.3725 4 5.83333 4H8.33333C8.33333 3.448 8.70583 3 9.16667 3H10.8333C11.2942 3 11.6667 3.448 11.6667 4H14.1667Z",
    fill: "#727B7F"
  }));
};